import applicant from './applicant-zh'
import archive from './archive-zh'
import calendar from './calendar-zh'
import dashboard from './dashboard-zh'
import drawing from './drawing-zh'
import exportStrings from './export-zh'
import findings from './findings-zh'
import history from './history-zh'
import importStrings from './import-zh'
import intakeStrings from './intake-zh'
import km from './km-zh'
import lettersStrings from './letters-zh'
import notificationStrings from './notifications-zh'
import oscStrings from './osc-zh'
import pages from './pages-zh'
import procedure from './procedure-zh'
import queueStrings from './queue-zh'
import registerExportStrings from './register-export-zh'
import registerPublic from './register-public-zh'
import registrations from './registrations-zh'
import settings from './settings-zh'
import trustStrings from './trust-zh'
import workflowStrings from './workflow-zh'

/** 规划许可（Kebenaran Merancang）模块的控制台文本。 */
export default {
  home: {
    title: '规划许可',
    subtitle: '规划提交、检查和审批将显示在此处。',
  },
  settings,
  findings,
  form: { ...pages.form, ...km.form },
  report: pages.report,
  detail: pages.detail,
  dashboard: dashboard.dashboard,
  activity: dashboard.activity,
  registrations,
  mySubmissions: applicant.mySubmissions,
  downloads: applicant.downloads,
  history: history.history,
  chain: history.chain,
  calendar: calendar.calendar,
  clocks: { ...calendar.clocks, names: km.clocks },
  procedure: procedure.procedure,
  roles: procedure.roles,
  export: exportStrings.export,
  authority: exportStrings.authority,
  sealKey: exportStrings.sealKey,
  archive: archive.archive,
  imports: importStrings.imports,
  queue: queueStrings.queue,
  trustedSystems: trustStrings.trustedSystems,
  externalIds: trustStrings.externalIds,
  osc: oscStrings.osc,
  workflow: workflowStrings.workflow,
  intake: intakeStrings.intake,
  inputs: km.inputs,
  flags: km.flags,
  counters: km.counters,
  drawingStandard: drawing.drawingStandard,
  findingHelp: drawing.findingHelp,
  nextStep: drawing.nextStep,
  checkWording: drawing.checkWording,
  placement: drawing.placement,
  registerExport: registerExportStrings.registerExport,
  notifications: notificationStrings.notifications,
  letters: lettersStrings.letters,
  copyFailed: '复制失败：请选中文本后手动复制。',
  list: {
    subtitle: '规划提交及其图纸检查与审批。',
    newSubmission: '新建提交',
    searchLabel: '搜索提交',
    searchPlaceholder: '编号、项目名称、申请人或文件名',
    search: '搜索',
    tabsLabel: '筛选提交',
    tabs: {
      all: '全部',
      awaiting: '待审核',
      approved: '已批准',
      returned: '已退回',
      failed: '失败',
      withdrawn: '已撤回',
      committee: '委员会审议中',
      refused: '已拒绝',
      in_force: '有效中',
    },
    columns: {
      title: '项目名称',
      applicant: '申请人',
      file: '文件',
      size: '大小',
      conversion: '图纸检查',
      approval: '审批',
      updated: '更新时间',
      actions: '操作',
    },
    view: '查看',
    empty: '暂无提交。',
    emptyFiltered: '没有符合此筛选条件的提交。',
    pageOf: '第 {{page}} 页，共 {{pages}} 页',
    previous: '上一页',
    next: '下一页',
    total: '提交：{{total}}',
  },
  status: {
    none: '—',
    conversion: { in_progress: '处理中', done: '已完成', failed: '失败' },
    approval: {
      awaiting: '待批准',
      approved: '已批准',
      returned: '已退回',
      withdrawn: '已撤回',
      refused: '已拒绝',
      lapsed: '已失效',
    },
  },
  stage: {
    draft: '草稿',
    checking: '检查中',
    check_failed: '检查未通过',
    awaiting_review: '待审核',
    approved: '已批准',
    returned: '已退回',
    withdrawn: '已撤回',
    deleted: '已删除',
    ...km.stage,
  },
  submissionStatus: {
    queued: '排队中',
    converting: '转换中',
    ingesting: '导入中',
    passed: '通过',
    passed_with_warnings: '通过（有警告）',
    failed: '未通过',
    error: '错误',
  },
  severity: { fail: '失败项', warn: '警告', info: '提示' },
  result: { passed: '检查通过', passed_with_warnings: '检查通过（有警告）', failed: '检查未通过' },
  actions: {
    submit: '提交',
    check_retry: '重新检查',
    resubmit: '重新提交',
    approve: '批准',
    return: '退回',
    withdraw: '撤回',
    delete: '删除',
    check_passed: '检查通过',
    check_failed: '检查未通过',
    check_errored: '检查无法运行',
    ...km.actions,
  },
  actionConfirm: {
    approve: '批准此提交？其场地和地块将移至已批准地图。',
    return: '将此提交退回给申请人。申请人将看到您的理由。',
    withdraw: '撤回此提交？此操作无法撤销。',
    delete: '删除此提交？它将从所有列表中消失；记录会被保留。',
    resubmit: '重新提交此提交以进行检查。请选择要检查的图纸。',
    resubmitSame: '使用同一图纸重新提交',
    resubmitSameHint: '最新图纸将作为下一版本再次检查。',
    resubmitReplace: '上传替换图纸',
    resubmitReplaceHint: '新图纸将成为下一版本。',
    resubmitNoPrevious: '没有可重用的早期图纸，请上传一份。',
    resubmitStoredHint: '您的替换图纸已上传，因此将检查该图纸。',
    resubmitUploading: '正在上传图纸… {{percent}}%',
    resubmitFinalizing: '正在检查上传…',
    resubmitSubmitting: '正在重新提交…',
    reasonLabel: '理由',
    reasonRequired: '请输入理由。',
    confirm: '确认',
    cancel: '取消',
  },
  guards: {
    form_valid: '表单尚未填写完整',
    documents_cad_present_or_reuse: '此版本尚未上传图纸',
    submission_current: '检查结果已过期',
    submission_latest_errored: '最近一次检查并未出错',
    check_latest_passed: '最近一次检查尚未通过',
    register_not_dead: '地图登记册有失败的更新',
    separation_of_duties: '批准人不能是最后提交人',
    input_reason_present: '需要填写理由',
    clock_running: '此步骤的期限已过或未在计时',
    clock_due: '期限尚未届满',
    ...workflowStrings.guards,
  },
  events: {
    case_created: '已创建',
    case_attributes_updated: '详情已更新',
    document_added: '图纸已上传',
    transition_submit: '已提交',
    transition_check_passed: '检查通过',
    transition_check_failed: '检查未通过',
    transition_check_errored: '检查无法运行',
    transition_check_retry: '已重新检查',
    transition_resubmit: '已重新提交',
    transition_approve: '已批准',
    transition_return: '已退回',
    transition_withdraw: '已撤回',
    transition_delete: '已删除',
    case_bound: '已绑定至其程序',
    document_reused: '已重复使用图纸',
    clock_started: '期限开始',
    clock_paused: '期限暂停',
    clock_resumed: '期限恢复',
    clock_stopped: '期限停止',
    clock_extended: '期限延长',
    clock_expired: '期限届满',
    clock_scheduled: '已设定截止日期',
    ...exportStrings.events,
    ...importStrings.events,
    ...workflowStrings.events,
    ...intakeStrings.events,
  },
  attributes: {
    keterangan: '说明',
    gtn1: '土地用途 (GTN1)',
    gtn2: '土地用途 (GTN2)',
    gtn3: '土地用途 (GTN3)',
    nama: '开发项目名称',
    pemajuan: '开发内容',
    pemaju: '开发商',
    no_fail: '档案编号',
    luas_hektar: '面积（公顷）',
    negeri: '州',
    daerah: '县',
    mukim: '巫金',
    no_lot: '地段编号',
    tahun_data: '数据年份',
    jenis_km: '规划许可类型',
    kaedah: 'OSC 提交方式',
    upi: '地段唯一标识码（UPI）',
  },
  map: {
    empty: '暂无可预览的几何图形。',
    legendClasses: '土地用途',
    legendStatus: '状态',
    statusApproved: '已批准',
    statusStaging: '暂存',
    statusCandidate: '未暂存（仅供诊断）',
    unclassified: '未分类',
  },
  timeline: {
    system: '系统',
    empty: '暂无事件。',
    reason: '理由：{{reason}}',
    stageChange: '{{from}} → {{to}}',
  },
  register: registerPublic,
  errors: {
    stale_case: '自您打开以来，此提交已发生变化。已重新加载，请重试。',
    stage_locked: '此提交在当前阶段无法编辑。',
    guard_failed: '暂时无法执行：{{guards}}。',
    actor_not_permitted: '您无权执行此操作。',
    not_planning_actor: '您没有规划角色。请管理员将您加入审核人或批准人组。',
    request_id_reused: '该请求已用于其他操作。请重新加载后重试。',
    upload_rejected: '图纸被拒绝（{{reason}}）。',
    register_server_not_configured: '尚未配置地图登记服务器。',
    register_server_locked: '一旦存在提交，地图登记服务器便无法更改。',
    invalid_settings: '部分设置无效。请修正下列项目后重新保存。',
    invalid_register_server: '所选的地图登记服务器无效。',
    registration_closed: '申请人注册已关闭。',
    rate_limited: '请求过多。请等待几分钟后重试。',
    registration_not_found: '未找到该注册申请。',
    registration_not_pending: '该注册申请已有决定。',
    identity_exists: '此邮箱的账户已存在。',
    email_in_use: '此邮箱已被另一组织的账户使用。',
    seats_exhausted: '此账户类型已无剩余席位。',
    seats_busy: '正在创建另一个账户，请稍后重试。',
    invalid_registration: '部分注册资料无效。',
    document_not_found: '此版本没有该文件。',
    invalid_calendar: '该日历无效。请修正下列项目后重试。',
    invalid_overlay: '这些调整无效。请修正下列项目后重新保存。',
    settings_required: '请先保存规划设置，再调整流程。',
    procedure_variant_unavailable:
      '无法加载正在使用的流程调整。管理员须在“设置 → 规划”中重新保存，或改回使用已发布的流程。',
    no_decision_tables: '此流程没有可下载的规则表。',
    openSettings: '打开规划设置',
    not_found: '未找到，或您无权查看。',
    network: '无法连接服务器。请检查网络后重试。',
    upload_aborted: '上传已取消。',
    upload_transport: '上传失败，请重试。',
    generic: '出现问题，请重试。',
    retryLoad: '重试',
    ...exportStrings.errors,
    ...importStrings.errors,
    ...queueStrings.errors,
    ...workflowStrings.errors,
    ...intakeStrings.errors,
    ...registerExportStrings.errors,
    ...notificationStrings.errors,
    ...lettersStrings.errors,
  },
} as const
